import { http } from '@/services';

export default {
  createNewPlan: async function(plan) {
    try {
      return await http.post(`plano/`, plan);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  putPlanData: async function(plan) {
    try {
      return await http.put(`plano/`, plan);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getPlanList: async function() {
    try {
      return await http.get(`plano/`);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getPlanListPublic: async function(residencia) {
    try {
      return await http.get(`plano/publico`, {
        params: residencia,
      });
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  deletePlan: async function(idPlano) {
    try {
      if (idPlano === undefined)
        return Promise.reject(
          new Error('Missing required  parameter: idPlano'),
        );
      return await http.delete(`plano/${idPlano}`);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
};
